export interface StorageKeySet {
  user: string;
  tokens: string;
}

export const createStorageKeys = (scope: string): StorageKeySet => ({
  user: `ecommerce_${scope}_userStorage`,
  tokens: `ecommerce_${scope}_authTokenStorage`,
});

export const STORE_STORAGE_KEYS = createStorageKeys("store");
export const ADMIN_STORAGE_KEYS = createStorageKeys("admin");
